class MainIngredients extends HTMLElement {
  constructor() {
    super();
    this.isInitialLoad = true;
    this.accordionInputs = [];
    this.isClosingOthers = false;
    this.observer = null;
    this.initialized = false;
  }

  connectedCallback() {
    this.initAccordionScroll();

    if (this.accordionInputs.length === 0 && !this.initialized) {
      this.observeForAccordions();
    }

    setTimeout(() => {
      this.isInitialLoad = false;
    }, 500);
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }

  observeForAccordions() {
    this.observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          const inputs = this.querySelectorAll('.accordions-item__input[type="checkbox"]');
          if (inputs.length > 0 && !this.initialized) {
            this.initAccordionScroll();
            if (this.observer) {
              this.observer.disconnect();
              this.observer = null;
            }
            break;
          }
        }
      }
    });

    this.observer.observe(this, {
      childList: true,
      subtree: true
    });
  }

  initAccordionScroll() {
    if (this.initialized) {
      return;
    }

    this.accordionInputs = this.querySelectorAll('.accordions-item__input[type="checkbox"]');

    if (this.accordionInputs.length === 0) {
      return;
    }

    const glossaryContainer = this.querySelector('.ingredients__glossary') || this;

    glossaryContainer.addEventListener('change', (event) => {
      if (event.target.classList.contains('accordions-item__input') && event.target.type === 'checkbox') {
        this.handleAccordionChange(event.target);
      }
    });

    this.initialized = true;

    this.accordionInputs = this.querySelectorAll('.accordions-item__input[type="checkbox"]');
  }

  handleAccordionChange(clickedInput) {
    this.accordionInputs = this.querySelectorAll('.accordions-item__input[type="checkbox"]');

    if (this.isClosingOthers) {
      return;
    }

    if (clickedInput.checked) {
      this.isClosingOthers = true;
      const accordionsToClose = [];

      this.accordionInputs.forEach((input) => {
        if (input !== clickedInput && input.checked) {
          accordionsToClose.push(input);
          input.checked = false;
        }
      });

      this.isClosingOthers = false;

      if (!this.isInitialLoad) {
        const accordionItem = clickedInput.closest('.accordions-item');
        const accordionContent = accordionItem?.querySelector('.accordions-item__content');

        if (accordionItem && accordionContent) {
          this.waitForAnimationsAndScroll(accordionsToClose, accordionContent, accordionItem);
        }
      }
    }
  }

  waitForAnimationsAndScroll(accordionsToClose, openingContent, targetElement) {
    let closedCount = 0;
    let openingComplete = false;
    const totalToClose = accordionsToClose.length;
    let scrollExecuted = false;

    const checkAndScroll = () => {
      if (closedCount === totalToClose && openingComplete && !scrollExecuted) {
        scrollExecuted = true;

        setTimeout(() => {
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              const rect = targetElement.getBoundingClientRect();
              const scrollMarginTop = parseInt(getComputedStyle(targetElement).scrollMarginTop) || 0;
              const targetPosition = window.scrollY + rect.top - scrollMarginTop;

              window.scrollTo({
                top: targetPosition,
                behavior: 'smooth'
              });
            });
          });
        }, 50);
      }
    };

    if (totalToClose > 0) {
      accordionsToClose.forEach((input) => {
        const content = input.closest('.accordions-item')?.querySelector('.accordions-item__content');
        if (content) {
          const onTransitionEnd = (event) => {
            if (event.propertyName === 'max-height') {
              closedCount++;
              content.removeEventListener('transitionend', onTransitionEnd);
              checkAndScroll();
            }
          };
          content.addEventListener('transitionend', onTransitionEnd);
        } else {
          closedCount++;
          checkAndScroll();
        }
      });
    } else {
      closedCount = totalToClose;
      checkAndScroll();
    }

    const onOpeningTransitionEnd = (event) => {
      if (event.propertyName === 'max-height') {
        openingComplete = true;
        openingContent.removeEventListener('transitionend', onOpeningTransitionEnd);
        checkAndScroll();
      }
    };
    openingContent.addEventListener('transitionend', onOpeningTransitionEnd);

    setTimeout(() => {
      if (!openingComplete || closedCount < totalToClose) {
        openingComplete = true;
        closedCount = totalToClose;
        checkAndScroll();
      }
    }, 600);
  }
}

customElements.define('main-ingredients', MainIngredients);

